<template>
  <div class="vehicle-card d-flex flex-column align-items-center justify-content-between">
    <div class="vehicle-card__header d-flex justify-content-end w-100">
      <button class="vehicle-card__header__info-button d-flex align-items-center d-none">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path id="stroke1"
                d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
                stroke="#0029FF" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path id="stroke2" d="M12 16V12" stroke="#0029FF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
          <path id="stroke3" d="M12 8H12.01" stroke="#0029FF" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </button>
      <slot name="seats"></slot>
    </div>

    <div class="vehicle-card__body d-flex flex-column align-items-center">
      <slot name="image"></slot>
    </div>

    <div class="vehicle-card__footer">
      <div class="vehicle-card__footer__wrapper">

        <slot name="maker_model"></slot>

        <slot name="price"></slot>

        <div class="hr-line"></div>

        <VehicleCardFreeItemWrapperComponent></VehicleCardFreeItemWrapperComponent>

      </div>

    </div>
  </div>

</template>

<script lang="ts">
import {defineComponent} from "vue";
import './vehicleCard.scss';
// @ts-ignore
import VehicleCardFreeItemWrapperComponent from "../../components/vehicleCardFreeItemWrapper/VehicleCardFreeItemWrapperComponent.vue";


export default defineComponent({
  name: 'VehicleCardComponent',
  components: {VehicleCardFreeItemWrapperComponent},
  props: {},
  data() {
    return {

    }
  }
});
</script>

